// Packages and components
import React, { useContext } from 'react';
import { Box } from 'grommet';
import { Next } from 'grommet-icons';
import LiveStreamIntroPage from '../Onboarding/LiveStream/LiveStreamSetUpIntroPage';
import SHDProgress from '@ui/Progress/SHDProgress';
import SHDText from '@ui/Text/SHDText';

// Helpers and utilities
import { analytics } from '@services/analytics';
import { useModal } from '@components/ModalContext';
import { useHistory } from 'react-router-dom';
// Types and enums
import { LiveStreamSetUpSteps } from '@theme/theme.d';
import useTeamTrackInfo from '@hooks/useTeamTrackInfo';
import { TeamContext } from '@services/Session';

interface TrackGameCardProps {
  screenSize: string;
}

const TrackGameCard: React.FC<TrackGameCardProps> = ({ screenSize }) => {
  const { showModal, hideModal } = useModal();
  const history = useHistory();
  const teamStore = useContext(TeamContext);
  const team = teamStore.fetchTeamInfo;
  const isAdmin = teamStore.isTeamManager;
  const { teamInfo, loading } = useTeamTrackInfo(teamStore.id);
  const games = teamInfo?.gameCount || 0;
  const players = teamInfo?.playerCount || 0;

  const progressValue = games > 0 ? players + 2 : 1;
  const subtitle =
    games === 0
      ? 'When is your next game?'
      : `Add players to roster ${players}/8`;
  //console.log(games, players?.lenght)
  const renderModal = (step: LiveStreamSetUpSteps) => {
    showModal(
      <LiveStreamIntroPage
        onClose={() => hideModal()}
        teamId={team?.id}
        isAdmin={isAdmin}
        teamName={team?.nameHandle}
        sportType={team?.sport}
        step={step}
        history={history}
      />,
      {
        onClose: () => hideModal(),
        className: 'is-transparent-controls',
      }
    );
  };

  const handleClick = () => {
    analytics.track('Livestream Setup Entered', {
      teamId: team?.id,
      source: 'tracker card',
      sport: team?.sport,
    });
    if (games === 0) {
      renderModal(LiveStreamSetUpSteps.NEXT_GAME_SELECTION);
    } else if (games > 0 && players === 0) {
      renderModal(LiveStreamSetUpSteps.ROSTER_SELECTION);
    } else if (games && players < 8) {
      if (window.location.search !== '?tab=roster') {
        history.replace(`${window.location.pathname}?tab=roster`);
      }
      renderModal(LiveStreamSetUpSteps.ROSTER_SELECTION);
    }
  };

  return (
    <>
      {!loading && (games < 1 || players < 8) ? (
        <Box
          background="white"
          border={{ color: '#D9D9D9' }}
          round="16px"
          onClick={handleClick}
          width={{
            width: screenSize === 'small' ? '100%' : 'initial',
            max: screenSize === 'small' ? '100%' : '25rem',
          }}
        >
          <Box
            direction="row"
            gap="xsmall"
            align="center"
            pad="small"
            round="medium"
            alignContent="center"
          >
            <SHDProgress
              value={progressValue}
              max={8}
              size="small"
              type="circle"
              color="brand"
            />

            <Box flex>
              <SHDText style="footnote-bold" color="black-alpha-50">
                GET READY
              </SHDText>
              <SHDText style="body-semibold">{subtitle}</SHDText>
            </Box>
            <Box flex={{ shrink: 0, grow: 0 }}>
              <Next size="10px" color="#BABABA" />
            </Box>
          </Box>
        </Box>
      ) : null}
    </>
  );
};

export default TrackGameCard;
